import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import { useState } from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { validateItemInput } from "../../requests/validation/validateItemInput";
import { v1 as uuidv1 } from "uuid";
import {
  CustomBackdrop,
  ItemDetailsFormCommon,
  LoadingButtonText,
  apiURI,
  authErrorRedirect,
  processImages,
} from "../../common";
import { useNavigate } from "react-router-dom";

export function SampleRequestApprovalProcurementAddItemModal(props) {
  // State to store any validation errors
  const [errors, setErrors] = useState();
  // State to store loading state
  const [isSubmitting, setIsSubmitting] = useState(false);
  // State to store new product images to be uploaded
  const [productImages, setProductImages] = useState([]);
  // State for storing boolean for progress of image compression
  const [isCompressing, setIsCompressing] = useState(false);
  // State for storing timer for Secondary Message in CustomBackdrop
  const [patienceTimer, setPatienceTimer] = useState(false);
  // State for storing form input values
  const [values, setValues] = useState({
    itemERPCode: "",
    itemDescription: "",
    specification: "",
    quantityForSample: "",
    preferredUnitOfMeasure: "",
    noOfSamplesRequired: "",
    productClass: "",
  });

  const history = useNavigate();

  const handleClose = () => {
    props.setOpen(false);
    setValues("");
    setIsSubmitting(false);
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  async function handleAddItem() {
    setErrors({});
    setIsSubmitting(true);
    // Process all of the images primed for upload - compress images and then convert to base64 before uploading
    let productImagesToUpload = await processImages(
      productImages,
      setPatienceTimer,
      setIsCompressing
    );

    let newData = {
      ...props.detailsData,
      itemList: [...props.itemList],
      item: {
        sampleItemID: `SI-ID-${uuidv1()}`,
        ...values,
        itemERPCode: values.itemERPCode ? values.itemERPCode : "N/A",
        productImage: productImagesToUpload,
      },
    };

    await axios
      .post(`${apiURI}/form/procAddItem`, newData)
      .then(() => window.location.reload(true))
      .catch((response) => {
        console.log("error in axios form call react");
        setErrors({});
        setErrors(response.response.data);
        authErrorRedirect(response.response.data, history);
      });

    setValues({
      sampleItemID: "",
      itemERPCode: "",
      itemDescription: "",
      specification: "",
      quantityForSample: "",
      preferredUnitOfMeasure: "",
      noOfSamplesRequired: "",
      productClass: "",
    });

    // Clear the product images array
    setProductImages([]);
    setIsSubmitting(true);
    handleClose();
    // eslint-disable-next-line no-console
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    const { validationErrors, isValid } = validateItemInput(values);
    !isValid && setErrors(validationErrors);

    isValid && handleAddItem(values);
  };
  errors && console.log({ errors });

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose} {...DialogProps}>
        <Box sx={{ display: props.display }}>
          <Container {...ContainerProps}>
            <Typography component="h1" variant="h5">
              Add Item
            </Typography>
            <Box {...FormBoxProps}>
              <ItemDetailsFormCommon
                values={values}
                onChange={onChange}
                errors={errors}
                productImage={productImages}
                setProductImage={setProductImages}
              />
              <Grid {...SaveButtonGridProps}>
                <Grid item>
                  <Button onClick={handleSubmit} {...SaveButtonProps}>
                    <LoadingButtonText loading={isSubmitting} text="Save" />
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
      </Dialog>
      <CustomBackdrop
        open={isCompressing}
        primaryMessage="Please wait: Compressing selected images"
        timer={patienceTimer}
        secondaryMessage="Larger images take longer to compress."
      />
    </div>
  );
}

const DialogProps = {
  style: {
    height: "90%",
  },
  PaperProps: { sx: { borderRadius: "10px" } },
};

const ContainerProps = {
  component: "main",
  maxWidth: "sm",
  sx: {
    marginTop: 4,
    flexDirection: "column",
    alignItems: "center",
  },
};

const FormBoxProps = {
  component: "form",
  noValidate: true,
  sx: {
    mt: 3,
  },
};

const SaveButtonGridProps = {
  container: true,
  spacing: 2,
  sx: {
    mt: 1,
    flexDirection: "row",
    justifyContent: "center",
  },
};

const SaveButtonProps = {
  variant: "contained",
  sx: {
    mt: 1,
    mb: 3,
    width: "150px",
  },
};
